module.exports = __webpack_public_path__ + "assets/images/project/solar-eclipse-header.jpg?v=6a74217c";